import react, { Component } from 'react';
import { PRODUCTS } from './configs';
import numeral from 'numeral';
import { Tooltip } from 'react-tooltip';
import { checkCouponCode } from '../query';
import Loading from '../../../components/Loading';
import { calculatePricePerInterval } from './utils';
import { formatNumber } from '../../../helpers/formatNumber';

class Interval extends Component {
    constructor(props) {
        super(props);
        this.calculatePrice = this.calculatePrice.bind(this);
        this.onTogglePromoCodeInput = this.onTogglePromoCodeInput.bind(this);
        this.onUpdatePromoCode = this.onUpdatePromoCode.bind(this);
        this.onSendPromoCode = this.onSendPromoCode.bind(this);
        this.onDeletePromoCode = this.onDeletePromoCode.bind(this);
        this.onSendDefaultPromoCode = this.onSendDefaultPromoCode.bind(this);

        this.url = new URL(window.location.href);
        this.abortRef = react.createRef();
        this.defaultPromoCodeRef = react.createRef();
        this.isTrial = window.user_permissions?.subscription_status === 'trialing';

        const promo_code =
            this.url.searchParams.get('promo_code') || props.defaultPromotionCode || '';

        this.state = {
            openPromoCodeInput: !!promo_code,
            promoCode: promo_code,
            promoCodeError: false,
            successPromoCode: false,
            results: {
                price: 0,
                interval: 'Month',
            },
            promoCodeLoading: !!promo_code,
            promoDefaultCodeLoading: false,
            promoCodeErrorMessage: '',
            promoData: null,
            defaultPromoData: null,
            defaultResults: {
                price: 0,
                interval: 'Month',
            },
        };
    }

    onUpdatePromoCode(newCode) {
        this.setState({ promoCode: newCode, promoCodeError: false });
    }

    async onSendDefaultPromoCode(prompotionCode) {
        try {
            const _price_ids = this.props.defaultPriceIds;
            const _prompotionCode = prompotionCode || this.state.defaultPromotionCode;

            if (!_prompotionCode || !_price_ids || _price_ids.length === 0) {
                return;
            }
            this.setState({
                promoDefaultCodeLoading: true,
            });
            const body = {
                promotion_code: _prompotionCode,
                price_items: _price_ids,
            };
            const res = await checkCouponCode(body);
            const data = await res.json();
            if (res.ok) {
                const body = {
                    defaultPromoData: data,
                    promoDefaultCodeLoading: false,
                };

                this.setState(body);
            } else {
                this.setState({ promoDefaultCodeLoading: false });
            }
        } catch (err) {
            console.log(err);
        }
    }

    async onSendPromoCode() {
        try {
            const _prompotionCode = this.state.promoCode;
            const _price_ids = this.props.priceIds;
            if (!_prompotionCode || Object.values(_price_ids)?.length === 0) {
                this.setState({
                    promoData: null,
                });
                return;
            }

            if (this.abortRef.current?.signal) {
                this.abortRef.current.abort();
            }
            this.abortRef.current = new AbortController();

            this.props.onChangeUserInfo('promotion_code', '');
            this.setState({
                promoCodeLoading: true,
                openPromoCodeInput: true,
                promoCodeError: false,
                promoCodeErrorMessage: '',
                promoData: null,
            });
            const body = {
                promotion_code: _prompotionCode,
                price_items: Object.values(_price_ids),
            };
            const controller = this.abortRef.current;
            const res = await checkCouponCode(body, controller?.signal);
            const data = await res.json();
            this.abortRef.current = null;
            if (res.ok) {
                const body = {
                    promoData: data,
                    successPromoCode: true,
                    promoCodeLoading: false,
                };

                this.setState(body);
                this.props.onChangeUserInfo('promotion_code', _prompotionCode);
                this.props.updatePromoCodeInfo(data);
                this.url = new URL(window.location.href);
                this.url.searchParams.set('promo_code', _prompotionCode);
                window.history.pushState({}, '', this.url);
            } else {
                this.setState({
                    promoCodeError: true,
                    successPromoCode: false,
                    promoCodeErrorMessage: data?.detail || 'This code is invalid',
                });
                this.props.deletePromoCodeInfo();
            }
            this.setState({ promoCodeLoading: false });
        } catch (err) {
            if (err.name !== 'AbortError') {
                this.setState({
                    promoCodeError: true,
                    successPromoCode: false,
                    promoCodeErrorMessage: 'This code is invalid',
                });
                this.setState({ promoCodeLoading: false });
                this.props.deletePromoCodeInfo();
            }
        }
    }

    onDeletePromoCode() {
        this.setState({
            promoCode: '',
            promoData: null,
            promoCodeError: false,
            successPromoCode: false,
        });
        this.props.deletePromoCodeInfo();
        this.url.searchParams.delete('promo_code');
        window.history.pushState({}, '', this.url);
    }

    onTogglePromoCodeInput() {
        this.setState((prevState) => ({
            openPromoCodeInput: !prevState.openPromoCodeInput,
        }));
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            JSON.stringify(prevProps.products) !== JSON.stringify(this.props.products) ||
            JSON.stringify(prevProps.addOns) !== JSON.stringify(this.props.addOns) ||
            JSON.stringify(prevProps.billingInfo) !== JSON.stringify(this.props.billingInfo) ||
            JSON.stringify(Object.values(prevProps.priceIds)) !==
                JSON.stringify(Object.values(this.props.priceIds)) ||
            prevProps.interval !== this.props.interval
        ) {
            const { billingInfo, products } = this.props;
            const { price, interval } = this.calculatePrice(billingInfo, products);
            const urlPromoCode = new URL(window.location.href).searchParams.get('promo_code');
            if (urlPromoCode && urlPromoCode !== this.state.promoCode) {
                this.setState(
                    { promoCode: urlPromoCode, openPromoCodeInput: true, successPromoCode: false },
                    () => {
                        this.onSendPromoCode();
                    },
                );
            } else {
                this.onSendPromoCode();
            }
            this.props.updateLastPrice(price);

            this.setState({
                results: {
                    price,
                    interval,
                },
            });
        }

        if (
            this.props.isEdit &&
            JSON.stringify(prevProps.defaultProducts) !== JSON.stringify(this.props.defaultProducts)
        ) {
            const { billingInfo, defaultProducts } = this.props;
            const { price, interval } = this.calculatePrice(billingInfo, defaultProducts, true);
            this.setState({
                defaultResults: {
                    price,
                    interval,
                },
            });
        }
        if (
            prevProps.defaultPromotionCode !== this.props.defaultPromotionCode ||
            JSON.stringify(Object.values(prevProps.defaultPriceIds)) !==
                JSON.stringify(Object.values(this.props.defaultPriceIds))
        ) {
            this.setState({
                promoCode:
                    this.url.searchParams.get('promo_code') ||
                    this.props.defaultPromotionCode ||
                    '',
            });
            const price_ids = this.props.defaultPriceIds;
            if (!price_ids || price_ids.length === 0) {
                return;
            }

            this.onSendDefaultPromoCode(this.props.defaultPromotionCode);
            this.defaultPromoCodeRef.current = true;
        }
    }

    calculatePrice(billingInfo, products, fromDefault) {
        if (billingInfo === null) {
            return { price: 0, interval: 'Month' };
        }
        let price = 0;
        let interval = 'Month';
        if (products.google_discover_analytics) {
            const prices = billingInfo.discoverAnalytics?.prices || [];
            const { price: discoverPrice, price_id: discoverPriceId } = calculatePricePerInterval(
                prices,
                products.google_analytics_domains,
                this.props.interval,
            );
            price += discoverPrice;

            const data = {
                price_id: discoverPriceId,
                quantity: products.google_analytics_domains
                    ? Number(products.google_analytics_domains)
                    : 0,
            };
            !fromDefault && this.props.updatePrices('google_discover_analytics', data);
        }

        if (products.google_search_analytics) {
            const prices = billingInfo.searchAnalytics?.prices || [];
            const { price: searchPrice, price_id: searchPriceId } = calculatePricePerInterval(
                prices,
                products.google_analytics_domains,
                this.props.interval,
            );
            price += searchPrice;
            const data = {
                price_id: searchPriceId,
                quantity: products.google_analytics_domains
                    ? Number(products.google_analytics_domains)
                    : 0,
            };
            !fromDefault && this.props.updatePrices('google_search_analytics', data);
        }
        if (products.ai_tracking) {
            const prices = billingInfo.ai_tracking?.prices || [];
            const { price: aiTrackingPrice, price_id: aiTrackingPriceId } =
                calculatePricePerInterval(
                    prices,
                    products.ai_tracking_prompts,
                    this.props.interval,
                );
            price += aiTrackingPrice;

            const data = {
                price_id: aiTrackingPriceId,
                quantity: products.ai_tracking_prompts ? Number(products.ai_tracking_prompts) : 0,
            };
            !fromDefault && this.props.updatePrices('ai_tracking', data);
        }
        if (products.commerce) {
            const prices = billingInfo.commerce?.prices || [];
            const { price: commercePrice, price_id: commercePriceId } = calculatePricePerInterval(
                prices,
                1,
                this.props.interval,
            );
            price += commercePrice;
            const data = {
                price_id: commercePriceId,
                quantity: 1,
            };
            !fromDefault && this.props.updatePrices('commerce', data);
        }

        if (this.props.addOns?.additionalSeats) {
            const additionalSeatsPrices = billingInfo.additional_seats?.prices || [];
            const { price: additionalSeatsPrice, price_id: additionalSeatsPriceId } =
                calculatePricePerInterval(
                    additionalSeatsPrices,
                    Number(this.props.addOns?.additionalSeats) || 0,
                    this.props.interval,
                );

            price += additionalSeatsPrice;
            const additionalSeatsData = {
                price_id: additionalSeatsPriceId,
                quantity: Number(this.props.addOns?.additionalSeats) || 0,
            };
            !fromDefault && this.props.updatePrices('additional_seats', additionalSeatsData);
        } else {
            !fromDefault && this.props.deleteItemFromPriceIds('additional_seats');
        }

        if (this.props.addOns?.contentAnalysis) {
            const contentAnalysisPrices = billingInfo.content_analysis?.prices || [];
            const { price: contentAnalysisPrice, price_id: contentAnalysisPriceId } =
                calculatePricePerInterval(
                    contentAnalysisPrices,
                    Number(this.props.addOns?.contentAnalysis) || 0,
                    this.props.interval,
                );
            price += contentAnalysisPrice;
            const contentAnalysisData = {
                price_id: contentAnalysisPriceId,
                quantity: Number(this.props.addOns?.contentAnalysis) || 0,
            };
            !fromDefault && this.props.updatePrices('content_analysis', contentAnalysisData);
        } else {
            !fromDefault && this.props.deleteItemFromPriceIds('content_analysis');
        }

        if (this.props.interval === 'quarterly') {
            interval = '3 Months';
        } else if (this.props.interval === 'annualy') {
            interval = '12 Months';
        } else {
            interval = 'Month';
        }

        const rounded = Number(price.toFixed(2)); // fix JS float precision
        price = Number.isInteger(rounded)
            ? numeral(rounded).format('0')
            : numeral(rounded).format('0.[00]');

        return { price, interval };
    }

    getIntervalLabels() {
        if (this.props.interval === 'quarterly') {
            return { short: '3 mo', period: 'first 3 months' };
        }
        if (this.props.interval === 'annualy') {
            return { short: 'yr', period: 'first year' };
        }
        return { short: 'mo', period: 'first month' };
    }

    formatPromotionLabel(promo) {
        if (!promo) return '';

        return (
            <div>
                <strong>
                    {this.state.promoData?.percent_off
                        ? `${this.state.promoData.percent_off}%`
                        : `-$${
                              this.state.promoData?.total_savings_cents
                                  ? this.state.promoData.total_savings_cents / 100
                                  : 0
                          }`}
                </strong>{' '}
                off{' '}
                {this.state.promoData?.duration_in_months ? (
                    <div>for {this.state.promoData?.duration_in_months || ''} month(s)</div>
                ) : null}{' '}
                {this.state.promoData?.applies_to_slugs?.length > 0
                    ? `(Applies for ${this.state.promoData.applies_to_slugs
                          ?.map((item) => PRODUCTS[item] || item)
                          .join(', ')} ${
                          this.state.promoData?.applies_to_slugs?.length === 1 ? 'only' : ''
                      })`
                    : ''}
            </div>
        );
    }

    render() {
        const { price, interval } = this.state.results;
        const { price: defaultPrice, interval: defaultInterval } = this.state.defaultResults;
        const priceValue = this.state.promoData?.total_savings_cents
            ? price - this.state.promoData.total_savings_cents / 100
            : price;

        // const defaultPriceValue = defaultPrice;
        const defaultPriceValue = this.state.defaultPromoData?.total_savings_cents
            ? defaultPrice - this.state.defaultPromoData.total_savings_cents / 100
            : defaultPrice;

        const diffPrice = priceValue - defaultPriceValue;

        return (
            <>
                <div className="custom-registration-body-step">
                    <div className="custom-registration-body-step-header">
                        <span>{this.props.step ?? 2}</span> Confirm your plan
                    </div>

                    <div className="custom-registration-body-step-body">
                        <div className="custom-registration-interval">
                            <div className="custom-registration-interval-left">
                                {this.props.isEdit ? (
                                    <div className="custom-registration-interval-boxs">
                                        <div className="custom-registration-interval-header">
                                            <div className="custom-registration-interval-box">
                                                <div className="custom-registration-interval-box-header">
                                                    Current Plan
                                                </div>
                                                <div className="custom-registration-interval-box-price">
                                                    {/* ${formatNumber(defaultPriceValue)}
                                                    <span>per {defaultInterval}</span> */}
                                                    {this.state.promoDefaultCodeLoading && (
                                                        <Loading onlyPreloader fontSize="35px" />
                                                    )}
                                                    {!this.state.promoDefaultCodeLoading &&
                                                        (this.state.defaultPromoData
                                                            ?.total_savings_cents ? (
                                                            <div>
                                                                <div>
                                                                    $
                                                                    {formatNumber(
                                                                        defaultPrice -
                                                                            this.state
                                                                                .defaultPromoData
                                                                                .total_savings_cents /
                                                                                100,
                                                                    )}
                                                                    / {defaultInterval}
                                                                </div>
                                                                <div className="custom-registration-interval-header-original-price">
                                                                    ${formatNumber(defaultPrice)}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                ${formatNumber(defaultPrice)}/{' '}
                                                                {defaultInterval}
                                                            </div>
                                                        ))}
                                                </div>
                                                <div className="custom-registration-interval-box-status">
                                                    Already active
                                                </div>
                                            </div>
                                        </div>
                                        <div className="custom-registration-interval-header">
                                            <div className="custom-registration-interval-box">
                                                <div className="custom-registration-interval-box-header">
                                                    New plan
                                                </div>
                                                <div className="custom-registration-interval-box-price">
                                                    <div className="custom-registration-interval-box-price">
                                                        {this.state.promoCodeLoading && (
                                                            <Loading
                                                                onlyPreloader
                                                                fontSize="35px"
                                                            />
                                                        )}
                                                        {!this.state.promoCodeLoading &&
                                                            (this.state.promoData
                                                                ?.total_savings_cents ? (
                                                                <div>
                                                                    <div>
                                                                        $
                                                                        {formatNumber(
                                                                            price -
                                                                                this.state.promoData
                                                                                    .total_savings_cents /
                                                                                    100,
                                                                        )}
                                                                        / {interval}
                                                                    </div>
                                                                    {this.state.promoData
                                                                        .duration === 'once' ? (
                                                                        <div className="custom-registration-interval-header-original-price no-line">
                                                                            A $
                                                                            {formatNumber(
                                                                                this.state.promoData
                                                                                    ?.total_savings_cents /
                                                                                    100,
                                                                            )}{' '}
                                                                            coupon will be applied
                                                                            to your first month.
                                                                            After that, your
                                                                            subscription will
                                                                            automatically renew at $
                                                                            {formatNumber(price)}{' '}
                                                                            per month. Cancel
                                                                            anytime.
                                                                        </div>
                                                                    ) : (
                                                                        <div className="custom-registration-interval-header-original-price">
                                                                            ${formatNumber(price)}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div>
                                                                    ${formatNumber(price)} /{' '}
                                                                    {interval}
                                                                </div>
                                                            ))}
                                                    </div>
                                                </div>
                                                <div className="custom-registration-interval-box-status">
                                                    Starting after this update
                                                </div>
                                            </div>
                                        </div>
                                        <div className="custom-registration-interval-header">
                                            <div className="custom-registration-interval-box">
                                                <div className="custom-registration-interval-box-header">
                                                    Changes in this update
                                                </div>
                                                <div
                                                    className={`custom-registration-interval-box-price ${
                                                        diffPrice >= 0 ? 'green-box' : 'red-box'
                                                    }`}
                                                >
                                                    {this.state.promoCodeLoading && (
                                                        <Loading onlyPreloader fontSize="35px" />
                                                    )}
                                                    {!this.state.promoCodeLoading && (
                                                        <>
                                                            {diffPrice >= 0 ? '+' : '-'}$
                                                            {formatNumber(Math.abs(diffPrice))} /{' '}
                                                            {interval}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="custom-registration-interval-header">
                                            <div className="custom-registration-interval-box">
                                                <div className="custom-registration-interval-box-header">
                                                    Due today
                                                </div>
                                                <div className="custom-registration-interval-box-price green-box">
                                                    {this.state.promoCodeLoading && (
                                                        <Loading onlyPreloader fontSize="35px" />
                                                    )}
                                                    {!this.state.promoCodeLoading && (
                                                        <>
                                                            $
                                                            {this.isTrial
                                                                ? 0
                                                                : formatNumber(
                                                                      Math.abs(
                                                                          diffPrice > 0
                                                                              ? diffPrice
                                                                              : 0,
                                                                      ),
                                                                  )}
                                                        </>
                                                    )}
                                                </div>
                                                <div className="custom-registration-interval-box-status">
                                                    You are only charged for this change
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : this.props.isFreeAiTemplate ? (
                                    <div className="custom-registration-interval-header">
                                        <div className="custom-registration-interval-header-price free-ai">
                                            $0
                                            <span>
                                                for the {this.getIntervalLabels().period}, then $
                                                {formatNumber(price)}/
                                                {this.getIntervalLabels().short} after trial
                                            </span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="custom-registration-interval-header-with-trial">
                                        <div className="custom-registration-interval-header">
                                            {this.state.promoCodeLoading && (
                                                <Loading onlyPreloader fontSize="35px" />
                                            )}
                                            {!this.state.promoCodeLoading &&
                                                (this.state.promoData?.total_savings_cents ? (
                                                    <div>
                                                        <div className="custom-registration-interval-header-price">
                                                            {this.state.promoData
                                                                ?.total_savings_cents ? (
                                                                <div>
                                                                    <div>
                                                                        $
                                                                        {formatNumber(
                                                                            price -
                                                                                this.state.promoData
                                                                                    ?.total_savings_cents /
                                                                                    100,
                                                                        )}
                                                                        / {interval}
                                                                    </div>
                                                                    <div className="custom-registration-interval-header-original-price">
                                                                        ${formatNumber(price)}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="custom-registration-interval-header-price">
                                                                    ${formatNumber(price)}
                                                                    <span>/ {interval}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="custom-registration-interval-header-price">
                                                        ${formatNumber(price)}
                                                        <span>/ {interval}</span>
                                                    </div>
                                                ))}
                                        </div>
                                        <div className="custom-registration-trial-pill">
                                            <span className="custom-registration-trial-pill-icon">
                                                🎁
                                            </span>
                                            <b>14-day free trial</b>
                                            <span className="custom-registration-trial-pill-note">
                                                For new users and new domains • Cancel anytime
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {this.props.defaultInterval &&
                                    this.props.interval !== this.props.defaultInterval && (
                                        <div className="custom-registration-interval-warning">
                                            Your current plan is "{this.props.defaultInterval}", you
                                            are changing it to "{this.props.interval}".
                                            <br />
                                            Changing Interval will update your invoice total cost,
                                            savings and billing period.
                                            {this.isTrial && (
                                                <>
                                                    <br />
                                                    You will not be charged until your trial ends,
                                                    but your billing period will be updated to the
                                                    new interval.
                                                </>
                                            )}
                                        </div>
                                    )}

                                <div className="custom-registration-interval-options">
                                    <div className="custom-registration-interval-options-item">
                                        <label className="custom-registration-radio">
                                            <input
                                                type="radio"
                                                name="interval"
                                                value="monthly"
                                                checked={this.props.interval === 'monthly'}
                                                onChange={() =>
                                                    this.props.onChangeInterval('monthly')
                                                }
                                            />
                                            <span className="radio-ui"></span>
                                            <div className="label-text">Monthly</div>
                                        </label>
                                    </div>
                                    <div className="custom-registration-interval-options-item">
                                        <label className="custom-registration-radio">
                                            <input
                                                type="radio"
                                                name="interval"
                                                value="quarterly"
                                                checked={this.props.interval === 'quarterly'}
                                                onChange={() =>
                                                    this.props.onChangeInterval('quarterly')
                                                }
                                            />
                                            <span className="radio-ui"></span>
                                            <div
                                                className="label-text"
                                                data-tooltip-id="upgrade-plan-tooltip"
                                            >
                                                Quarterly <span>Save 10%</span>
                                            </div>
                                        </label>
                                    </div>
                                    <div className="custom-registration-interval-options-item">
                                        <label className="custom-registration-radio">
                                            <input
                                                type="radio"
                                                name="interval"
                                                value="annualy"
                                                checked={this.props.interval === 'annualy'}
                                                onChange={() =>
                                                    this.props.onChangeInterval('annualy')
                                                }
                                            />
                                            <span className="radio-ui"></span>
                                            <div
                                                className="label-text"
                                                data-tooltip-id="upgrade-plan-tooltip"
                                            >
                                                Annual <span>Save 15%</span>
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {this.props.isFreeAiTemplate && (
                                <div className="custom-registration-interval-right">
                                    <div className="custom-registration-interval-cancel-anytime">
                                        <i className="icon-check-icon" />
                                        Cancel anytime
                                    </div>
                                </div>
                            )}
                            {!this.props.isFreeAiTemplate && (
                                <div className="custom-registration-interval-right">
                                    {this.state.successPromoCode ? (
                                        <div className="custom-registration-interval-success-promo-code">
                                            <div className="custom-registration-interval-success-promo-code-box">
                                                <img src="/static/img/Tag.svg" />
                                                {this.state.promoCode}
                                                {this.state.promoCodeLoading ? (
                                                    <Loading onlyPreloader />
                                                ) : (
                                                    <button onClick={this.onDeletePromoCode}>
                                                        <i className="icon-x-close" />
                                                    </button>
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-end gap-4 text">
                                                {this.formatPromotionLabel(this.state.promoData)}
                                            </div>
                                        </div>
                                    ) : !this.state.openPromoCodeInput ? (
                                        <button
                                            className="custom-registration-interval-header-promo-code-btn"
                                            onClick={this.onTogglePromoCodeInput}
                                        >
                                            Add a promo code
                                        </button>
                                    ) : (
                                        <div>
                                            <form
                                                className={
                                                    'custom-registration-interval-promo-code-input' +
                                                    (this.state.promoCodeError ? ' error' : '')
                                                }
                                            >
                                                <input
                                                    value={this.state.promoCode}
                                                    className={'form-control'}
                                                    onChange={(e) =>
                                                        this.onUpdatePromoCode(e.target.value)
                                                    }
                                                    placeholder="Enter promo code"
                                                    disabled={this.state.promoCodeLoading}
                                                />
                                                <div className="custom-registration-interval-promo-code-input-actions">
                                                    {!this.state.promoCodeError ? (
                                                        <button
                                                            className="custom-registration-interval-promo-code-input-actions-apply"
                                                            onClick={() => this.onSendPromoCode()}
                                                            disabled={
                                                                this.state.promoCodeLoading ||
                                                                !this.state.promoCode
                                                            }
                                                        >
                                                            {this.state.promoCodeLoading && (
                                                                <Loading onlyPreloader />
                                                            )}
                                                            Apply
                                                        </button>
                                                    ) : (
                                                        <button
                                                            className="custom-registration-interval-promo-code-input-actions-close"
                                                            onClick={this.onDeletePromoCode}
                                                            type="button"
                                                        >
                                                            <i className="icon-x-close" />
                                                        </button>
                                                    )}
                                                </div>
                                            </form>
                                            {this.state.promoCodeError && (
                                                <div className="custom-registration-interval-promo-code-error">
                                                    {this.state.promoCodeErrorMessage ||
                                                        'This code is invalid'}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="upgrade-plan-tooltip-container">
                    <Tooltip id="upgrade-plan-tooltip" place="bottom">
                        <div className="upgrade-tooltip-content">
                            <img src="/static/img/Offer.svg" alt="Upgrade" />
                            Upgrade to save more!
                        </div>
                    </Tooltip>
                </div>
            </>
        );
    }
}

export default Interval;
